const URL = process.env.VUE_APP_URL_FRONT || "http://localhost:8081";
const BASE_URL_BFF = process.env.VUE_APP_BASE_URL_BFF || "http://localhost:8000";
const WS_URL = process.env.VUE_APP_WS_URL;
let DEBUG_MODE = process.env.VUE_APP_DEBUG_MODE || false;
const SECRET_KEY = process.env.VUE_APP_TURNTSTILE_SECRET_KEY;
const SITE_KEY = process.env.VUE_APP_TURNSTILE_SITEKEY;

// console.log("process.env.VUE_APP_BASE_URL_BFF", process.env.VUE_APP_BASE_URL_BFF)
// console.log("BASE_URL_BFF", BASE_URL_BFF)

if (DEBUG_MODE == "1"){
  DEBUG_MODE = true
}else
  DEBUG_MODE = false

module.exports = {
  URL:  URL,
  BASE_URL_BFF: BASE_URL_BFF,
  WS_URL: WS_URL,
  DEBUG_MODE: DEBUG_MODE,
  SECRET_KEY: SECRET_KEY,
  SITE_KEY: SITE_KEY
};
